import ReceiptPrinters from './ReceiptPrinters';

export default ReceiptPrinters;
